/** Сезон: шкала и обмен кристаллов — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { SeasonView } from "./view";
import { appStore, serverNow, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import {
  balanceV1,
  earlyHero,
  seasonDaysLeft,
  seasonStep,
  seasonSteps,
  seasonUnclaimed,
  waveBaseReward,
} from "@newfungame/engine";
import { playSound } from "../../../audio";
import { useBuy } from "../offers";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    season: object;
  }
}

export function Season({ close }: WindowProps<"season">) {
  const player = useStore(appStore, (s) => s.player);
  const canPay = useStore(appStore, (s) => s.miniApp);
  const { busy, buy } = useBuy("season");
  const def = balanceV1.season;
  const s = player?.season ?? null;
  if (!player || !s || !def) return null;
  const now = serverNow(appStore.get());
  const daysLeft = seasonDaysLeft(s.endsAt, now);
  const step = seasonStep(def, s.points);
  const views = seasonSteps(balanceV1, def, s, player.bestWave, daysLeft);
  const heroId = earlyHero(balanceV1, def, player.heroes, player.bestWave);
  return (
    <SeasonView
      season={s}
      def={def}
      daysLeft={daysLeft}
      step={step}
      steps={views}
      unclaimed={seasonUnclaimed(balanceV1, def, s, player.bestWave)}
      passStars={player.prices.season}
      crystals={player.crystals}
      skipTickets={player.skipTickets}
      speedTickets={player.speedTickets}
      speedActive={(player.speedUntil ?? 0) > now}
      bagCoins={def.shop.bagWaves * waveBaseReward(balanceV1, Math.max(1, player.bestWave))}
      heroId={heroId}
      canPay={canPay}
      busy={busy}
      onClaim={() => {
        playSound("purchase");
        actions().claimSeason();
      }}
      onBuyPass={() => buy("season")}
      onTelegram={() => actions().openTelegram("season")}
      onSpend={(item) => {
        playSound("purchase");
        void actions().spend(item);
      }}
      onClose={close}
    />
  );
}

export function register(): void {
  registerWindow("season", Season);
}
